import {
  PUBLICATIONLANGS,
  SITELANGS,
  WorkEditedWork
} from "@balthasarspeyr/common";
import React, { FC } from "react";
import { ReactComponent as TrashIcon } from "../../../static/icons/trash.svg";
import {
  Actions,
  Cell,
  Row,
  WhiteButton
} from "../../../styles/styledcomponets";

interface IWorkElemProps {
  work: Partial<WorkEditedWork>;
  deleteHandler: (id: string) => void;
  workIDHandler: (id: string, state: States) => void;
}

enum States {
  LISTING = 0,
  ADDING = 1,
  EDITING = 2
}

const EditedWorkElem: FC<IWorkElemProps> = ({
  work,
  deleteHandler,
  workIDHandler
}) => {
  return (
    <Row key={work.id}>
      <Cell>
        {work.editedAuthor?.name.en} {work.editedAuthor?.surname?.en}
      </Cell>
      <Cell>
        {work.title?.[work.originalLang || SITELANGS.en] || work.title?.en}
      </Cell>
      <Cell>
        {work?.authors?.[0]?.author?.name?.en}{" "}
        {work?.authors?.[0]?.author?.surname?.en}
      </Cell>
      <Cell>{work?.year}</Cell>
      <Cell>
        <Actions>
          <WhiteButton
            margin="auto 5px auto 5px"
            onClick={() => workIDHandler(work.id || "", States.EDITING)}
          >
            Edit
          </WhiteButton>
          <TrashIcon onClick={() => deleteHandler(work.id!)} />
        </Actions>
      </Cell>
    </Row>
  );
};

export default EditedWorkElem;
